module.exports = __webpack_public_path__ + "img/poster-1.7d6f4902.png";